import useGetDetail, { UseGetDetailOptions } from '../core-hooks/useGetDetail'
import queryKeys from '../query-keys'
import useCreateDetail, {
  UseCreateDetailOptions,
} from '../core-hooks/useCreateDetail'
import useDeleteDetail, {
  UseDeleteDetailOptions,
} from '../core-hooks/useDeleteDetail'
import useUpdateDetail, {
  UseUpdateDetailOptions,
} from '../core-hooks/useUpdateDetail'
import useGetList, { UseGetListOptions } from '../core-hooks/useGetList'
import useUpdateList, {
  UseUpdateListOptions,
} from '../core-hooks/useUpdateList'
import useDeleteList, {
  UseDeleteListOptions,
} from '../core-hooks/useDeleteList'
import buildService from '../create-service'
import { InfoType } from '@/types/info-types'

const service = buildService<InfoType>({
  pathCategory: 'info_types',
})

export function useGetInfoType({
  id,
  ...options
}: UseGetDetailOptions<InfoType>) {
  const query = useGetDetail<InfoType>({
    id,
    queryKey: queryKeys.infoTypes.detail({ id, filters: options.filters }),
    serviceFn: service.getDetail,
    ...options,
  })

  return {
    infoType: query.data,
    ...query,
  }
}

export function useCreateInfoType(
  options: UseCreateDetailOptions<InfoType> = {},
) {
  const mutation = useCreateDetail<InfoType>({
    serviceFn: service.createDetail,
    ...options,
  })

  return {
    createInfoType: mutation.mutateAsync,
    ...mutation,
  }
}

export function useUpdateInfoType(
  options: UseUpdateDetailOptions<InfoType> = {},
) {
  const mutation = useUpdateDetail<InfoType>({
    serviceFn: service.updateDetail,
    ...options,
  })

  return {
    updateInfoType: mutation.mutateAsync,
    ...mutation,
  }
}

export function useDeleteInfoType(options: UseDeleteDetailOptions = {}) {
  const mutation = useDeleteDetail<InfoType>({
    serviceFn: service.deleteDetail,
    ...options,
  })

  return {
    deleteInfoType: mutation.mutateAsync,
    ...mutation,
  }
}

export function useGetInfoTypes({
  filters,
  ...options
}: UseGetListOptions<InfoType> = {}) {
  const query = useGetList<InfoType>({
    filters,
    queryKey: queryKeys.infoTypes.list({ filters }),
    serviceFn: service.getList,
    ...options,
  })

  return {
    infoTypes: query.allData,
    ...query,
  }
}

export function useUpdateInfoTypes(
  options: UseUpdateListOptions<InfoType> = {},
) {
  const mutation = useUpdateList<InfoType>({
    serviceFn: service.updateList,
    ...options,
  })

  return {
    updateInfoTypes: mutation.mutateAsync,
    ...mutation,
  }
}

export function useDeleteInfoTypes({
  sideEffectQueryKeys,
  listQueryKey,
  ...options
}: UseDeleteListOptions = {}) {
  const mutation = useDeleteList<InfoType>({
    serviceFn: service.deleteList,
    sideEffectQueryKeys,
    listQueryKey,
    ...options,
  })

  return {
    deleteInfoTypes: mutation.mutateAsync,
    ...mutation,
  }
}
